import React, { useState } from "react";
import Navbar from "./Navbar";
import NavBottom from "./NavBottom";
import pic2 from "./Images/pic2.jpg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlogCard from "./BlogCard";
import Blogs from "./BlogData"
import NewsCard from "./NewsCard";
import News from "./NewsData"

const Blog = () => {
    return (
        <>
            <Navbar />
            <div className="i-main">
                <div className="page-title">
                    <h1>Blog</h1>
                </div>
                <div className="i-elem">
                    <div className="i-ideas">
                        {Blogs.map(obj => {
                            return <BlogCard image={obj.image} info={obj.text} like={obj.vote} link={obj.link} see={obj.see} />
                        })}
                    </div>
                </div>

                <div className="page-title">
                    <h1>News</h1>
                </div>
                <div className="i-news">
                    <div className="i-ideas i-news-ideas">
                        {News.map(obj => {
                            return <NewsCard image={obj.image} info={obj.info} link={obj.url} />
                        })}
                    </div>
                </div>
            </div>
            <NavBottom />
        </>
    )
}

export default Blog;